import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { RegistrationForm } from "./RegistrationForm";
import { useTranslation } from "react-i18next";
import { getUser, logout } from "@newsenec/auth-provider";
import { Link, Stack, Typography } from "@mui/material";
import { RegistrationStep } from "./RegistrationScreen";
import { SenecScreenTemplate } from "../SenecScreenTemplate";

export const RegistrationStart = ({
    setRegistrationStep,
    setError,
}: {
    setRegistrationStep: Dispatch<SetStateAction<RegistrationStep>>;
    setError: Dispatch<SetStateAction<string | undefined>>;
}) => {
    const [userName, setUserName] = useState<string | undefined>();
    const { t } = useTranslation();

    useEffect(() => {
        getUser()
            .then((user) => setUserName(user?.name))
            .catch(() => {
                /*
          do nothing - no user name will be displayed
          retry screen will be shown if registering fails
          */
            });
    }, []);

    return (
        <SenecScreenTemplate
            title={t("registrationScreenWelcome")}
            content={
                <>
                    {userName && <Typography fontWeight="bold">{userName}</Typography>}
                    <Typography>{t("registrationScreenEnterDataPrompt")}</Typography>
                    <RegistrationForm setRegistrationStep={setRegistrationStep} setError={setError}></RegistrationForm>
                </>
            }
            footer={
                <Stack direction="row" spacing={2} alignItems="center">
                    <img src="/mek-logo.png" alt="MyEnergyKey Icon" height="30px"></img>
                    <Stack alignItems="flex-start">
                        <Typography textAlign="left">{t("registrationScreenChangeMEKAccountPrompt")}</Typography>
                        <Link component="button" onClick={async () => logout()}>
                            <Typography textAlign="left">{t("registrationScreenLogoutOfMEKAccountPrompt")}</Typography>
                        </Link>
                    </Stack>
                </Stack>
            }
        />
    );
};
